import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default function HorizontalAnchorLink({
    global,
    pathPrefix,
    customClass = "",
    post
}) {

    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`} >
                <Container>
                    <hr></hr>
                    <Row className="d-flex flex-wrap">
                        {post?.map((post, index) => (
                            <Card className="bg-transparent border-0 d-flex align-items-center" key={index}>
                                <AnchorLink offset='100' href={`#${post.url_slug}`} className="pb-2 primaryBtn no-arrow m-0 d-flex w-100 h-100 align-items-center justify-content-center">
                                    {post?.title}
                                </AnchorLink>
                            </Card>
                        ))}
                    </Row>
                </Container>
            </section>
        )
    )
}